module.exports = __webpack_public_path__ + "static/media/Picture3.8258b3e2.png";